<script>
import OrganizationStaffList from '@/fcl/components/user/OrganizationStaffList'
import BottomToolbar from '@/fcl/components/user/BottomToolbar'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-staff-list',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'organization-staff-list': OrganizationStaffList,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            staffList: null,
            organizationId: null,
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onStaffItemClick(item) {
            console.log('onStaffItemClick', item)
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'UserOrgDetailStaff',
                    params: {
                        id: item.id
                    },
                    query: {
                        organizationId: this.organizationId
                    }
                }
            })
        },
        onStaffItemCreate() {
            console.log('onCreateBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'UserOrgCreateStaff',
                    query: {
                        organizationId: this.organizationId
                    }
                }
            })
        },
        onStaffInvite(item) {
            console.log('onStaffInvite', item)
            this.$emit('custom-event', {
                type: 'invite-staff',
                data: {
                    id: item.id,
                    organizationId: this.organizationId,
                    roleLabel: item.roleLabel,
                    name: item.name
                }
            })
        },
        onCreateBtnClick() {
            console.log('onCreateBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'UserOrgCreateStaff',
                    query: {
                        organizationId: this.organizationId
                    }
                }
            })
        },
    },
}
</script>
<template>
    <div class="staff-list">
        <organization-staff-list
            :staffList="staffList"
            :staffEmptyHint="locale['staff-empty-hint']"
            :staffInviteLabel="locale['invite-label']"
            :isRoleNameShow="true"
            @create-item="onStaffItemCreate"
            @click-item="onStaffItemClick"
            @invite-staff="onStaffInvite"
        />
        <bottom-toolbar 
            type="button" 
            :mainButtonLabel="locale['create']"
            @click-main-button="onCreateBtnClick"
        />
    </div>
</template>